var _defineProperty = require("/codebuild/output/src2234831700/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/defineProperty.js");
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var debugBuild = require('../debug-build.js');
var semanticAttributes = require('../semanticAttributes.js');
var logger = require('../utils-hoist/logger.js');
var spanUtils = require('../utils/spanUtils.js');

/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */
function setMeasurement(name, value, unit) {
  var activeSpan = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : spanUtils.getActiveSpan();
  var rootSpan = activeSpan && spanUtils.getRootSpan(activeSpan);
  if (rootSpan) {
    debugBuild.DEBUG_BUILD && logger.logger.log("[Measurement] Setting measurement on root span: ".concat(name, " = ").concat(value, " ").concat(unit));
    rootSpan.addEvent(name, _defineProperty(_defineProperty({}, semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE, value), semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT, unit));
  }
}

/**
 * Convert timed events to measurements.
 */
function timedEventsToMeasurements(events) {
  if (!events || events.length === 0) {
    return undefined;
  }
  var measurements = {};
  events.forEach(function (event) {
    var attributes = event.attributes || {};
    var unit = attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
    var value = attributes[semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
    if (typeof unit === 'string' && typeof value === 'number') {
      measurements[event.name] = {
        value: value,
        unit: unit
      };
    }
  });
  return measurements;
}
exports.setMeasurement = setMeasurement;
exports.timedEventsToMeasurements = timedEventsToMeasurements;